import { OrganizationType } from 'types/api';

export enum DeployableName {
    PLATFORM = 'platform',
    HOSPITAL = 'hospital',
    MEDICARD = 'medicard',
    ADMIN = 'admin',
}

const ORGANIZATION_TYPES_BY_DEPLOYABLE: Record<
    DeployableName,
    readonly OrganizationType[]
> = {
    [DeployableName.PLATFORM]: [
        OrganizationType.ATOMIX,
        OrganizationType.INSURANCE,
    ],
    [DeployableName.HOSPITAL]: [
        OrganizationType.PH_HOSPITAL,
        OrganizationType.ID_HOSPITAL,
    ],
    [DeployableName.MEDICARD]: [OrganizationType.MEDICARD],
    [DeployableName.ADMIN]: [OrganizationType.ADMIN],
};

export type DeployableAccessDecision =
    | { kind: 'allowed' }
    | { kind: 'redirect'; url: string }
    | { kind: 'denied' };

export const organizationCanAccessDeployable = (
    deployable: DeployableName,
    organizationType: OrganizationType,
) => ORGANIZATION_TYPES_BY_DEPLOYABLE[deployable].includes(organizationType);

const getDeploymentAppUrl = (deploymentUrl: string | null): URL | null => {
    if (!deploymentUrl) return null;

    try {
        const url = new URL(deploymentUrl);
        url.pathname = '/app';
        url.search = '';
        url.hash = '';
        return url;
    } catch {
        return null;
    }
};

export const getDeployableAccessDecision = ({
    deployable,
    organizationType,
    deploymentUrl,
    currentOrigin,
}: {
    deployable: DeployableName;
    organizationType: OrganizationType;
    deploymentUrl: string | null;
    currentOrigin: string;
}): DeployableAccessDecision => {
    if (organizationCanAccessDeployable(deployable, organizationType)) {
        return { kind: 'allowed' };
    }

    const target = getDeploymentAppUrl(deploymentUrl);
    if (!target || target.origin === currentOrigin) {
        return { kind: 'denied' };
    }

    return { kind: 'redirect', url: target.toString() };
};
